module.exports = __webpack_public_path__ + "prod/1.42.2/img/distribution-five.10d13410.png";